import { Dispatch, SetStateAction } from "react";
import { Property } from "../../../../../models/Property";
import { propertyNameFormatter, propertySaleStatus } from "../../../../../utilities/propertyUtilities";
import MobileCarousel from "../../../../shared/carousel/mobile/MobileCarousel";
import 'pure-react-carousel/dist/react-carousel.es.css';

interface MobileHeaderProps {
	property: Property;
	setShowImageModal?: Dispatch<SetStateAction<boolean>>;
};

export default function MobileHeader({ property }: MobileHeaderProps) {
	const { siteBuildingAddress, siteBuildingCity, siteBuildingState, siteBuildingZipCode } = property;
	const addressString = `
    ${siteBuildingAddress ? siteBuildingAddress + ' |' : ''} 
    ${siteBuildingCity + ', ' + siteBuildingState + ' ' + siteBuildingZipCode}`;

	const propertyName = propertyNameFormatter(property);
	const propertyStatus = propertySaleStatus(property);

	return (
		<header className='mobile-header'>
			<MobileCarousel property={property} />
			<div className="mobile-header--property-info">
				<div className="flex-col">
					<div className='summary-page--building-title'>
						{`${propertyName}${propertyStatus}`}
					</div>
					<div className="summary-page--address">
						<div>{addressString}</div>
					</div>
				</div>
			</div>
		</header>
	);
}